module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-div"
  }, [_c('div', {
    attrs: {
      "id": "titleAndSearch"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('pages.gradebook.title')))]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_vm._v(_vm._s(_vm.$t('pages.gradebook.search')) + " "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    attrs: {
      "id": "query",
      "name": "query"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }, function($event) {
        return _vm.filterData()
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "div-scroll"
  }, [_c('table', [_c('thead', [_c('tr', _vm._l((_vm.columns), function(key, i) {
    return _c('th', {
      key: key + i,
      class: {
        'Ime': (i === 0), 'Sum': (i === _vm.columnsLength)
      },
      on: {
        "click": function($event) {
          return _vm.sortBy(i)
        }
      }
    }, [(i == _vm.columnsLength) ? _c('div', {
      staticClass: "Sum-div table-header"
    }, [_vm._v("Σ")]) : (i !== 0) ? _c('div', {
      staticClass: "table-header",
      on: {
        "dblclick": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$refs.examResultsPreview.showCurrentResults(_vm.matrix.exams[i - 1].id, 1)
        }
      }
    }, [_vm._v(_vm._s(key))]) : _c('div', {
      staticClass: "Ime-div table-header"
    }, [_vm._v(_vm._s(_vm.$t('pages.gradebook.name')))])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.gridDataVisible.length), function(i) {
    return _c('tr', {
      directives: [{
        name: "observe-visibility",
        rawName: "v-observe-visibility",
        value: ({
          callback: function (isVisible, entry) { return _vm.visibilityChanged(isVisible, entry, i); },
          once: true
        }),
        expression: "{callback: (isVisible, entry) => visibilityChanged(isVisible, entry, i), once:true}"
      }],
      key: _vm.gridDataVisible[i - 1] + i.toString()
    }, _vm._l(((_vm.gridDataVisible[i - 1].length - 1)), function(j) {
      return _c('td', {
        key: _vm.gridDataVisible[i - 1][j - 1] + j.toString(),
        class: {
          'left-column': ((j - 1) === 0), 'table-light': (i - 1) % 2, 'table-white': i % 2, 'sum-column': (j - 1 === _vm.columnsLength)
        }
      }, [_c('div', {
        staticClass: "table-divs",
        class: {
          'left-column-div': ((j - 1) === 0), 'column-div': ((j - 1) !== 0 && _vm.gridDataVisible[i - 1][j - 1] !== null), 'column-div-green': ((j - 1) !== 0 && _vm.gridDataVisible[i - 1][j] >= 50), 'sum-column-div': ((j - 1) === _vm.columnsLength)
        },
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "dblclick": function($event) {
            return _vm.goToUserProfile(i - 1, j - 1)
          }
        }
      }, [_vm._v("\n                " + _vm._s(_vm.gridDataVisible[i - 1][j - 1]) + "\n            ")])])
    }), 0)
  }), 0)])]), _vm._v(" "), _c('exam-results-preview', {
    ref: "examResultsPreview"
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c618ebf0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c618ebf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/group/Gradebook.vue
// module id = 1473
// module chunks = 1